import React from 'react';
import IconButton from '../../IconButton';
import Tooltip from '../../Tooltip';
import Text from '../../Text';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import { arrowsDirection, dataHooks } from '../constants';
import { classes } from '../ModalPreviewLayout.st.css.js';
import classNames from 'classnames';
const tooltipProps = {
    [arrowsDirection.rightArrow]: {
        dataHook: dataHooks.nextNavigationButtonTooltip,
        placement: 'right',
    },
    [arrowsDirection.leftArrow]: {
        dataHook: dataHooks.prevNavigationButtonTooltip,
        placement: 'left',
    },
};
const iconButtonProps = {
    [arrowsDirection.leftArrow]: {
        dataHook: dataHooks.modalPreviewLeftArrow,
        children: React.createElement(ChevronLeft, null),
    },
    [arrowsDirection.rightArrow]: {
        dataHook: dataHooks.modalPreviewRightArrow,
        children: React.createElement(ChevronRight, null),
    },
};
const NavigationButton = ({ direction, tooltipText, onClick }) => (React.createElement("div", { className: classNames(classes.navigationButton, classes[direction]) },
    React.createElement(Tooltip, { disabled: !tooltipText, className: classes.modalTooltip, appendTo: "scrollParent", content: React.createElement(Text, { children: tooltipText }), ...tooltipProps[direction] },
        React.createElement(IconButton, { as: "button", skin: "transparent", onClick: onClick, ...iconButtonProps[direction] }))));
export default NavigationButton;
//# sourceMappingURL=NavigationButton.js.map